import { useReport } from './hooks/use-context';

export function OccurrenceDescription() {
  const { body } = useReport();

  const { occurrence_type, occurence_description } = body;

  const cellStyle = {
    padding: '4px 8px',
    border: '1px solid black',
    textAlign: 'left' as const,
  };

  const valueStyle = {
    textAlign: 'center' as const,
    backgroundColor: '#ffffcc',
  };

  return (
    <div style={{ marginBottom: '8px' }}>
      {/* Header row with occurrence type */}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '4fr 2fr 4fr',
          gap: '0',
        }}
      >
        <div
          style={{
            backgroundColor: '#d3d3d3',
            textAlign: 'center',
            padding: '4px',
            fontWeight: 'bold',
            border: '1px solid black',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          DESCRIÇÃO DA OCORRÊNCIA
        </div>
        <div
          style={{
            ...cellStyle,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontWeight: 'bold',
          }}
        >
          TIPO DE OCORRÊNCIA
        </div>
        <div style={{ ...cellStyle, ...valueStyle }}>
          {occurrence_type?.answers?.[0]?.content ||
            occurrence_type?.answers?.[0]?.option ||
            '-'}
        </div>
      </div>

      {/* Description content */}
      <div
        style={{
          ...cellStyle,
          ...valueStyle,
          padding: '8px',
          minHeight: '60px',
        }}
      >
        {occurence_description?.answers?.[0]?.content || '-'}
      </div>
    </div>
  );
}
